import {
  SET_STSORDENESRX,
  UPDATE_STSORDENRX_IN_ARRAY,
  ADD_STSORDENRX_IN_ARRAY,
} from "./stsOrdenesRxTypes";

export const stsOrdenesRxReducers = (state = [], action) => {
  switch (action.type) {
    case SET_STSORDENESRX:
      return action.payload;
    case ADD_STSORDENRX_IN_ARRAY:
      return [action.payload, ...state];

    case UPDATE_STSORDENRX_IN_ARRAY:
      const index = state.findIndex((orden) => orden.id === action.payload.id);
      const newArray = [...state];
      newArray[index] = action.payload;
      return newArray;
    default:
      return state;
  }
};
